type BunchBallQuizProps = {
  token: string;
  server: string;
  userId: string;
  quizId: string;
};

// Formerly served from https://bunchball-mobile-hub.s3.us-west-2.amazonaws.com/sandbox/31fe2b10a3c44ffe8c1d8b5c3c3ec769/site.css
// but moved to our servers because we couldn't figure out how to get Bunchball to update the file for us
import quizDotCss from '../../../assets/quiz.file.css';

export function BunchBallQuiz(props: BunchBallQuizProps): JSX.Element {
  return (
    <div className="modal-content">
      <bunchball-quiz
        data-token={props.token}
        data-server={props.server}
        data-user-id={props.userId}
        data-quiz-id={props.quizId}
        data-bypass-resume="false"
        data-custom-css={JSON.stringify([quizDotCss])}
        data-empty-message="No quizzes available at the moment..."
      />
    </div>
  );
}
